import React, { useState } from 'react';
import { ArrowLeft, Send, CheckCircle, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setIsSubmitted(true);
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      setIsSubmitted(false);
    }, 3000);
  };
  return <div className="min-h-screen bg-white" data-id="element-94">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-95">
        <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-96">
          <a href="#" className="flex items-center space-x-2 text-white hover:text-cyan-400 transition-colors" data-id="element-97">
            <ArrowLeft className="w-5 h-5" data-id="element-98" />
            <span className="font-medium" data-id="element-99">Back to Home</span>
          </a>
        </div>
      </nav>

      <main className="pt-24 pb-16" data-id="element-100">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-101">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-102">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-103">
              Get in Touch
            </h1>
            <p className="text-lg text-slate-600 mb-12" data-id="element-104">
              Have a question or want to learn more about our products? Send us
              a message and we'll get back to you as soon as possible.
            </p>

            {isSubmitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center" data-id="element-105">
                <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" data-id="element-106" />
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-107">
                  Message Sent!
                </h3>
                <p className="text-slate-600" data-id="element-108">
                  Thank you for reaching out. We'll respond to your message
                  shortly.
                </p>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-109">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-110">
                  <div data-id="element-111">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-900 mb-2" data-id="element-112">
                      Name *
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all" placeholder="John Doe" data-id="element-113" />
                  </div>

                  <div data-id="element-114">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-900 mb-2" data-id="element-115">
                      Email *
                    </label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all" placeholder="john@example.com" data-id="element-116" />
                  </div>
                </div>

                <div data-id="element-117">
                  <label htmlFor="subject" className="block text-sm font-medium text-slate-900 mb-2" data-id="element-118">
                    Subject *
                  </label>
                  <input type="text" id="subject" name="subject" required value={formData.subject} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all" placeholder="How can we help you?" data-id="element-119" />
                </div>

                <div data-id="element-120">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-900 mb-2" data-id="element-121">
                    Message *
                  </label>
                  <textarea id="message" name="message" required value={formData.message} onChange={handleChange} rows={6} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all resize-none" placeholder="Tell us more about your inquiry..." data-id="element-122" />
                </div>

                <Button type="submit" size="lg" disabled={isSubmitting} className="w-full md:w-auto" data-id="element-123">
                  {isSubmitting ? <>
                      <span className="inline-block animate-spin mr-2" data-id="element-124">⏳</span>
                      Sending...
                    </> : <>
                      Send Message
                      <Send className="ml-2 w-4 h-4" data-id="element-125" />
                    </>}
                </Button>
              </form>}

            <div className="mt-12 pt-12 border-t border-slate-200" data-id="element-126">
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-127">
                Other Ways to Reach Us
              </h3>
              <div className="space-y-4 text-slate-600" data-id="element-128">
                <div className="flex items-start space-x-3" data-id="element-129">
                  <MapPin className="w-5 h-5 text-cyan-600 mt-0.5 flex-shrink-0" data-id="element-130" />
                  <div data-id="element-131">
                    <p className="font-medium text-slate-900" data-id="element-132">Address</p>
                    <p className="text-slate-600" data-id="element-133">
                      500 Marquette Ave
                      <br data-id="element-134" />
                      Albuquerque, NM 87102
                    </p>
                  </div>
                </div>
                <p data-id="element-135">
                  <span className="font-medium text-slate-900" data-id="element-136">Email:</span>{' '}
                  <a href="mailto:info@remotesystems.xyz" className="text-cyan-600 hover:text-cyan-500 transition-colors" data-id="element-137">
                    info@remotesystems.xyz
                  </a>
                </p>
                <p className="text-sm text-slate-500" data-id="element-138">
                  We typically respond within 24-48 hours during business days.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}